import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { gaPageView } from "./lib/ga";

function RouteTracker() {
  const loc = useLocation();
  useEffect(() => { gaPageView(loc.pathname + loc.search); }, [loc.pathname, loc.search]);
  // Reset scroll to top on every route change (unless navigating to an in-page anchor).
  useEffect(() => {
    if (loc.hash) return;
    window.scrollTo(0, 0);
  }, [loc.pathname, loc.search, loc.hash]);
  return null;
}
import Home from "./pages/Home";
import Valuation from "./pages/Valuation";
import Privacy from "./pages/Privacy";
import CityLanding from "./pages/CityLanding";
import NeighborhoodLanding from "./pages/NeighborhoodLanding";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import About from "./pages/About";
import HowItWorks from "./pages/HowItWorks";
import Services from "./pages/Services";
import DirectSale from "./pages/DirectSale";
import SellingCosts from "./pages/SellingCosts";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

function Protected({ children }) {
  const { admin, ready } = useAuth();
  if (!ready) return <div className="min-h-screen bg-brand-cream" />;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <RouteTracker />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/valuation" element={<Valuation />} />
          <Route path="/sell/:citySlug" element={<CityLanding />} />
          <Route path="/sell/:citySlug/:hoodSlug" element={<NeighborhoodLanding />} />
          <Route path="/about" element={<About />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/services" element={<Services />} />
          <Route path="/what-we-do" element={<Services />} />
          <Route path="/2-percent-direct-sale" element={<DirectSale />} />
          <Route path="/selling-costs" element={<SellingCosts />} />
          <Route path="/cost-to-sell-a-home" element={<SellingCosts />} />
          <Route path="/santa-clara-county-2-percent-commission-direct-buyer" element={<DirectSale />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
